var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"modal-inventory-products-show-image"}},[_c('b-modal',{attrs:{"id":_vm.modalName,"title":"Image Preview","scrollable":"","hide-footer":""}},[_c('b-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('b-img',{attrs:{"src":_vm.url}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }